import React, { useEffect, useState } from 'react'
import { BasicModalCPProps, ModalCP } from 'submodules/nerit-framework-ui/common/components/modal/ModalCP'
import { TextAreaCP } from 'submodules/nerit-framework-ui/common/components/form-fields/text-area/TextAreaCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ParameterControlRequests } from 'submodules/nerit-aquatec-sdk/services/parameter-control/ParameterControlRequests'
import { ParameterNoteFormModel } from 'modules/collection-performance/components/parameter-control/modal-parameter-note/inner/ParameterNoteFormModel'

interface ICPProps extends BasicModalCPProps {
    locationCode: number
    locationName: string
    fieldCode: number
    fieldName: string
    year: number
    month: number
    note?: string
}

/**
 * Modal de edicao da nota de uma celula do Controle de Parametros (Tela 3.3).
 * O status e derivado e somente leitura; aqui so se edita a observacao.
 * Nota vazia remove a observacao existente.
 */
export function ModalParameterNoteCP(props: ICPProps): JSX.Element {

    const [formModel, setFormModel] = useState<ParameterNoteFormModel>(new ParameterNoteFormModel())
    const formStateManager = useFormStateManager(formModel)

    const saveRequest = useRequest<void>('none')
    useEffect(onSaveRequestChange, [saveRequest.isAwaiting])

    useEffect(init, [props.visible])

    /**
     */
    function init(): void {

        if (!props.visible) {
            setFormModel(new ParameterNoteFormModel())
            return
        }

        setFormModel(new ParameterNoteFormModel({ note: props.note }))
    }

    /**
     */
    function onClickSave(): void {

        const formValues = formStateManager.getFormValues()!
        saveRequest.runRequest(ParameterControlRequests.saveNote({
            locationCode: props.locationCode,
            fieldCode: props.fieldCode,
            year: props.year,
            month: props.month,
            note: formValues.note ?? '',
        }))
    }

    /**
     */
    function onSaveRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(saveRequest, NotificationHelper.DEFAULT_ERROR_SAVE_MESSAGE, NotificationHelper.DEFAULT_SUCCESS_SAVE_MESSAGE, true))
            return

        props.onSave()
    }

    return (
        <ModalCP
            visible={props.visible}
            actionLoading={saveRequest.isAwaiting}
            onOk={onClickSave}
            onCancel={props.onCancel}
            title={`${props.fieldName} — ${props.locationName}`}
            width={460}
        >
            <TextAreaCP
                label={'Observação'}
                formStateManager={formStateManager}
                fieldName={'note'}
                minRows={3}
            />
        </ModalCP>
    )
}
